export default "__VITE_ASSET__ed7df951__"